<app-page-header
  [pageTitle]="'Prospectos'"
  [showCreateButton]="permissionAuth.canCreate('prospectos')"
  [textButton]="'Nuevo prospecto'"
  (onCreateClick)="create()"
/>

<!-- Filtros -->
<app-filters-container
  [hasData]="prospectos.length > 0"
  [hasActiveFilters]="hasActiveFilters"
  [loading]="loading"
  (clearFilters)="clearFilters()"
>
  <app-search-input
    label="Buscar"
    [value]="filtros.busqueda"
    placeholder="Nombre, documento, email, teléfono..."
    containerClass="flex-1 min-w-80"
    (searchChange)="onSearchChange($event)"
  />

  <app-filter-select
    label="Tipo"
    [value]="filtros.tipo"
    [options]="tipoOptions"
    (valueChange)="onTipoChange($event)"
  />

  <app-filter-select
    label="Estado"
    [value]="filtros.es_cliente"
    [options]="estadoOptions"
    (valueChange)="onEstadoChange($event)"
  />

  <app-filter-select
    label="Canal de captación"
    [value]="filtros.canal_captacion_id"
    [options]="canalesCaptacionOptions"
    (valueChange)="onCanalCaptacionChange($event)"
  />
</app-filters-container>

<!-- Tabla -->
<app-data-table
  [columns]="columns"
  [data]="prospectos"
  [loading]="loading"
  (rowClick)="onRowClick($event)"
>
  <!-- Razón social -->
  <ng-template appTableCell="razon_social" let-prospecto>
    <div class="flex flex-col">
      @if (prospecto.tipo === 'F') {
        @if (prospecto.nombre && prospecto.apellido) {
          <span>{{ prospecto.nombre + ' ' + prospecto.apellido }}</span>
        }
      }
      @if (prospecto.nombre_empresa && prospecto.tipo === 'J') {
        <span>{{ prospecto.nombre_empresa }}</span>
      }
      @if (prospecto.documento) {
        @if (prospecto.documento_tipo_nombre) {
          <small>{{ prospecto.documento_tipo_nombre }}: {{ prospecto.documento }}</small>
        } @else {
          <small>DOC: {{ prospecto.documento }}</small>
        }
      }
    </div>
  </ng-template>

  <!-- Tipo -->
  <ng-template appTableCell="tipo" let-prospecto>
    <div class="flex items-center gap-1">
      @if (prospecto.tipo === 'J') {
        <app-badge [startIcon]="'apartment'">Persona jurídica</app-badge>
      } @else {
        <app-badge [startIcon]="'person'" [color]="'light'">Persona física</app-badge>
      }
    </div>
  </ng-template>

  <!-- Fecha solicitud -->
  <ng-template appTableCell="fecha_solicitud" let-prospecto>
    @if (prospecto.fecha_solicitud) {
      <span>{{ prospecto.fecha_solicitud | date:'dd/MM/yyyy' }}</span>
    } @else {
      <span class="text-gray-400 dark:text-gray-500">-</span>
    }
  </ng-template>

  <!-- Canal de captación -->
  <ng-template appTableCell="canal_captacion" let-prospecto>
    <div class="flex flex-col">
      <span>{{ prospecto.canal_captacion_nombre }}</span>
      <small>COD: {{ prospecto.canal_captacion_codigo }}</small>
    </div>
  </ng-template>

  <!-- Contacto -->
  <ng-template appTableCell="contacto" let-prospecto>
    <div class="flex flex-col">
      <span>{{ prospecto.email }}</span>
      <span>Teléfono: {{ prospecto.telefono }}</span>
      @if (prospecto.whatsapp) {
        <span>Whatsapp: {{ prospecto.whatsapp }}</span>
      }
    </div>
  </ng-template>

  <!-- Estado -->
  <ng-template appTableCell="estado" let-prospecto>
    @if (prospecto.es_cliente) {
      <app-badge [startIcon]="'check_circle'" [color]="'success'">Es cliente</app-badge>
    } @else {
      <app-badge [startIcon]="'schedule'" [color]="'warning'">Pendiente</app-badge>
    }
  </ng-template>

  <!-- Acciones -->
  <ng-template appTableCell="acciones" let-prospecto let-index="index">
    <app-delete-trigger *hasPermission="'prospectos:delete'"
      [title]="'Eliminar prospecto'"
      [disabled]="deleting && (index === deletingIndex)"
      (clickDeleteEvent)="delete(prospecto.id, index)"
    />
  </ng-template>
</app-data-table>

<!-- Paginación -->
<app-pagination
  [currentPage]="currentPage"
  [lastPage]="lastPage"
  [perPage]="perPage"
  [total]="total"
  (pageChange)="onPageChange($event)"
  (perPageChange)="onPerPageChange($event)"
/>
